import { useEffect } from 'react';

export const useBeforeUnloadListener = (disable = false) => {
    const handleBeforeUnload = (event: any) => {
        if (!disable) {
            event.preventDefault();
            event.returnValue = '';
        }
    };

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [disable]);
};
